import styled from 'styled-components';
import { body2, borderRadius, colors, fonts, heading4 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const PreviewWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  min-height: ${pxToRem(600)};
  height: fit-content;
  background-color: ${colors.backgroundSecondary};
  width: 100%;
  border-radius: ${borderRadius.xl};
  font-family: ${fonts.sansSerif};
  color: ${colors.textSecondary};
`;

export const CampaignTemplateWrapper = styled.div`
  flex: 1;
  width: 100%;
  min-height: ${pxToRem(750)};
  max-width: ${pxToRem(1088)};
`;

export const CampaignTemplateContainer = styled.div`
  min-height: ${pxToRem(600)};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${pxToRem(20)};
`;

export const TemplateContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${pxToRem(10)};
`;

export const TemplateContentTitle = styled.h2`
  ${heading4};
  margin-top: 0;
  margin-bottom: 0;
`;

export const TemplateContentBody = styled.div`
  ${body2};
  color: ${colors.secondaryText};
  max-width: ${pxToRem(350)};
  text-align: center;
`;

export const Buttons = styled.div`
  display: flex;
  gap: ${pxToRem(16)};
`;
